import React from 'react';
import { Button, Select, Space, Typography, Row, Col } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { ActionButtons } from './ActionButtons';
import { getAnswer } from '../utils/helpers';
import { renderTerminologySystemSelect, renderTerminologySelect } from '../utils/renderHelpers';
import { DEFAULT_SNOMED_SYSTEM } from '../utils/constants';
import DebouncedInput from './DebouncedInput';

const { Text } = Typography;

/**
 * Checkbox with Select Item Component - For checkbox-with-select rendering type
 */
export const CheckboxWithSelectItem = ({
  answer,
  pageIndex,
  sectionIndex,
  questionIndex,
  answerIndex,
  updateSchema,
  handleCloneAnswer,
  handleDeleteAnswer
}) => (
  <div style={{ padding: 12, borderRadius: 4, border: '1px solid #f0f0f0', marginBottom: 8 }}>
    <Space direction="vertical" style={{ width: '100%' }} size={8}>
      <div>
        <Text strong style={{ fontSize: '12px', display: 'block', marginBottom: 4 }}>Checkbox Label</Text>
        <DebouncedInput
          placeholder="Checkbox label"
          value={answer.checkboxLabel || ''}
          onChange={(e) => {
            updateSchema((newSchema) => {
              const ans = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
              if (ans) ans.checkboxLabel = e.target.value;
            });
          }}
          size="small"
          style={{ marginBottom: 8 }}
        />
        <Row gutter={8}>
          <Col span={8}>
            {renderTerminologySystemSelect(
              answer.checkboxTerminologySystem,
              (value) => {
                updateSchema((newSchema) => {
                  const ans = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
                  if (ans) {
                    ans.checkboxTerminologySystem = value;
                    ans.checkboxTerminology = null;
                    ans.checkboxConceptCode = '';
                  }
                });
              },
              'small'
            )}
          </Col>
          <Col span={16}>
            {renderTerminologySelect({
              systemUrl: answer.checkboxTerminologySystem || DEFAULT_SNOMED_SYSTEM,
              value: answer.checkboxTerminology?.id || answer.checkboxConceptCode || '',
              ...(answer.checkboxTerminology && { defaultValue: answer.checkboxTerminology }),
              onChange: (selectedValue, terminologyObject) => {
                updateSchema((newSchema) => {
                  const ans = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
                  if (!ans) return;
                  if (terminologyObject) {
                    ans.checkboxTerminology = terminologyObject;
                    ans.checkboxConceptCode = terminologyObject.code;
                    // Only auto-fill label if it's empty
                    if (!ans.checkboxLabel && terminologyObject.display) {
                      ans.checkboxLabel = terminologyObject.display;
                    }
                  } else {
                    ans.checkboxTerminology = null;
                    ans.checkboxConceptCode = '';
                  }
                });
              },
              size: 'small'
            })}
          </Col>
        </Row>
      </div>

      <div>
        <Text strong style={{ fontSize: '12px', display: 'block', marginBottom: 4 }}>Select Options</Text>
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {answer.selectOptions?.map((option, optionIndex) => (
            <Row gutter={8} key={optionIndex} align="middle">
              <Col flex="auto">
                <DebouncedInput
                  placeholder="Option label"
                  value={option.label || ''}
                  onChange={(e) => {
                    updateSchema((newSchema) => {
                      const answer = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
                      const opt = answer?.selectOptions?.[optionIndex];
                      if (opt) opt.label = e.target.value;
                    });
                  }}
                  size="small"
                />
              </Col>
              <Col>
                <Button
                  type="text"
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    updateSchema((newSchema) => {
                      const answer = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
                      if (answer?.selectOptions) answer.selectOptions.splice(optionIndex, 1);
                    });
                  }}
                />
              </Col>
            </Row>
          ))}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => {
              updateSchema((newSchema) => {
                const answer = getAnswer(newSchema, pageIndex, sectionIndex, questionIndex, answerIndex);
                if (answer) {
                  if (!answer.selectOptions) answer.selectOptions = [];
                  answer.selectOptions.push({ label: '' });
                }
              });
            }}
            size="small"
            block
          >
            Add Select Option
          </Button>
        </Space>
      </div>

      <Row gutter={8} align="middle">
        <Col flex="auto" />
        <Col>
          <ActionButtons
            onClone={() => handleCloneAnswer(pageIndex, sectionIndex, questionIndex, answerIndex)}
            onDelete={() => handleDeleteAnswer(pageIndex, sectionIndex, questionIndex, answerIndex)}
            size="small"
            cloneTitle="Clone checkbox with select item"
          />
        </Col>
      </Row>
    </Space>
  </div>
);





